import { useEffect } from 'react';
import { RefundProps } from '../types';

export const RefundOther = (props: RefundProps) => {
  const { onCompleted } = props;

  useEffect(() => {
    onCompleted();
  }, []);

  return null;
};
